import React from 'react';

import EllipseIcon from "components/icons/EllipseIcon";

import {blue500} from "assets/jss/main";

function NotificationNotReadIcon(props) {
    return (
        <div style={{marginRight: '4px'}}>
            <EllipseIcon color={blue500} />
        </div>
    );
}

export default NotificationNotReadIcon;
